import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'customCurrency',
  standalone: true,
})
export class CustomCurrencyPipe implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe) {}

  transform(
    value: number | string,
    currencyCode: string = 'Rp',
    display: string = 'symbol',
    digitsInfo: string,
  ): string {
    // Приведение значения к числу
    const num = typeof value === 'string' ? parseFloat(value) : value;

    // Проверка на NaN или некорректные значения
    if (isNaN(num)) {
      return '';
    }

    // Если число равно 0, возвращаем 'Rp 0'
    if (num === 0) {
      return `${currencyCode} 0`;
    }

    // Если число меньше 1000, возвращаем его с символом валюты без форматирования
    if (num < 1000) {
      return `${currencyCode} ${num}`;
    }

    // Для чисел >= 1000 используем CurrencyPipe с форматом '1.0-0'
    return this.currencyPipe.transform(num, `${currencyCode} `, display, '3.0') || '';
  }
}
